import Canvas from "./canvas";
import CanvasCrop from "./canvas-crop";
import ClearBtn from "./clear-btn";
import { PreviewComponent } from "../types";

const Preview = ({
  service,
  image,
  imageWidth,
  imageHeight,
  canvasIsChanged,
  showClearPopup,
  clearAll,
  cropDimensions,
  setCropDimensions,
  dispatch,
  cropIsSaveProportions,
  cropPosition,
  setCropPosition,
  canvasRef,
  canvasCropperRef,
  setChange,
  setCanvasInputValue,
  editImage,
  canvasDimension,
  canvasRotationAngle,
  isFlipVertical,
  isFlipHorizontal,
  canvasFormat,
  changeImage,
  getCanvasImage,
  analytics,
  showPopup
}: PreviewComponent) => {
  if (!image) return <></>;

  const style = { backgroundImage: `url(${image})` };

  return (
    <div className="service__preview">
      <ClearBtn
        isAddedImage={!!image}
        canvasIsChanged={canvasIsChanged}
        helpers={false}
        isWhite={true}
        showClearPopup={showClearPopup}
        clearAll={clearAll} 
        showPopup={showPopup} 
        sendShowRemovePopup={analytics.sendShowRemovePopup} 
        dispatch={dispatch} />
      <div className="service__preview-background" style={style}></div>
      <div className="service__preview-image">
        {service === "cropper" ? (
          <CanvasCrop
            canvasRef={canvasRef}
            setChange={setChange}
            setCanvasInputValue={setCanvasInputValue}
            canvasCropperRef={canvasCropperRef}
            cropPosition={cropPosition}
            setCropPosition={setCropPosition}
            cropIsSaveProportions={cropIsSaveProportions}
            dispatch={dispatch}
            setCropDimensions={setCropDimensions}
            service={service}
            image={image}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            cropDimensions={cropDimensions}
          />
        ) : (
          <Canvas
            service={service}
			image={image}
            editImage={editImage}
            canvasWidth={canvasDimension.width}
            canvasHeight={canvasDimension.height}
            canvasRotationAngle={canvasRotationAngle}
            isFlipVertical={isFlipVertical}
            isFlipHorizontal={isFlipHorizontal}
            canvasFormat={canvasFormat}
            createImage={getCanvasImage}
            changeImage={changeImage}
          />
        )}
      </div>
    </div>
  );
};

export default Preview;
